export default __webpack_public_path__ + "static/media/IGStories.edcee5f5.png";